import { deleteRequest } from '../..';

const deleteBuilding = (LocationId: string) => deleteRequest('locations/buildings', { LocationId });

export default deleteBuilding;
